//angular imports
import { 
  ChangeDetectionStrategy, 
  Component, 
  input, 
  signal
} from "@angular/core";

//local imports
import {
  CloseDialogMessage,
  CommandModel,
  Messenger,
} from "@app/shared";

import {
  CreateRoomRequest,
  ProgramProjectMismatchFault,
  RoomAlreadyExistsMessage,
  RoomDetails,
  RoomHttpService,
  ProgramProjectMismatchMessage,
  ProgramModel,
  ProjectModel,
  RoomTypeModel
} from "@app/catalog";

import { 
  ToastLevel, 
  ToastMessage
 } from "@app/components";
 
import { RoomAlreadyExistsFault } from "@app/catalog-common";


@Component({
  selector: "add-room-form",
  templateUrl: "./add-room-form.component.html",
  styleUrl: "./add-room-form.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AddRoomFormComponent {
  public details = RoomDetails.empty();

  public programs = input.required<ProgramModel[]>();
  public projects = input.required<ProjectModel[]>();

  public types = signal<RoomTypeModel[]>([
    { id: 'S', name: signal('Standard') },
    { id: 'V', name: signal('Variable') }
  ]);

  public companyId = input.required<string>();

  public cancelCommand = new CommandModel({
    executeAction: () => {
      this.messenger.send(new CloseDialogMessage());
      return Promise.resolve();
    },
  });

  public submitCommand = new CommandModel({
    executeAction: () => this.save(),
    isValid: this.details.isValid,
  });

  constructor(
    private roomHttpService: RoomHttpService,
    private messenger: Messenger,
  ) {}

  private save = async () => {
    let request = new CreateRoomRequest();

    request.name = this.details.name.value();
    request.code = this.details.code.value();
    request.subCode = this.details.subCode.value();
    request.type = this.details.type.value();
    request.nsf = this.details.nsf.value();
    request.programId = this.details.program.value();
    request.projectId = this.details.project.value();
    request.companyId = this.companyId();

    let createResult = this.roomHttpService.create(request);

    try {
      await createResult.response;
      this.messenger.send(new CloseDialogMessage());
    } catch (error) {
      if (error instanceof RoomAlreadyExistsFault) {
        this.messenger.send(
          ToastMessage.create(
            new RoomAlreadyExistsMessage(error.code),
            ToastLevel.Warning,
          ),
        );
      } else if (error instanceof ProgramProjectMismatchFault) {
        let program = this.programs().find(
          (item) => item.id === request.programId,
        );
        let project = this.projects().find(
          (item) => item.id === request.projectId,
        );

        this.messenger.send(
          ToastMessage.create(
            new ProgramProjectMismatchMessage(program.name(), project.name()),
            ToastLevel.Warning,
          ),
        );
      }
      return;
    }
  };
}
